export type IRI = string;

export type LDObject<T> = {
  "@context"?: string;
  "@id": string;
  "@type": T;
};

export type HydraView = {
  "@id": IRI;
  "@type": string;
  "hydra:first": string;
  "hydra:last": string;
  "hydra:next": string;
};

export type HydraCollection<T> = LDObject<"hydra:Collection"> & {
  "hydra:member": T[];
  "hydra:totalItems": number;
  "hydra:view"?: HydraView;
  "hydra:search"?: {
    "@type": string;
    "hydra:template": string;
    "hydra:variableRepresentation": string;
    "hydra:mapping": [
      {
        "@type": string;
        variable: string;
        property: string;
        required: boolean;
      }
    ];
  };
};

export type FlatHydraCollection<T> = {
  member: T[];
  totalItems: number;
  firstPage?: string;
  lastPage?: string;
  nextPage?: string;
};

export const flattenHydraCollection = <T>(
  collection: HydraCollection<T> | undefined | null
): FlatHydraCollection<T> => {
  const view = collection?.["hydra:view"];
  return {
    member: collection?.["hydra:member"] || [],
    totalItems: collection?.["hydra:totalItems"] || 0,
    firstPage: view?.["hydra:first"],
    lastPage: view?.["hydra:last"],
    nextPage: view?.["hydra:next"],
  };
};

export type HydraSearchParams = {
  page?: number;
  itemsPerPage?: number;
};

export type PureObject<T, O = any> = Omit<T, keyof LDObject<O>>;

export type ExtractHydraCollectionMember<
  Hydra extends HydraCollection<unknown>
> = Hydra["hydra:member"][number];
